import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import { MicrosoftOutlookEmailFoldersListInput } from "@cohesive/api-entities";
import { useQuery } from "@tanstack/react-query";

export function useOutlookEmailFoldersList(
  connection: IntegrationConnection,
  input: MicrosoftOutlookEmailFoldersListInput = {},
) {
  return useQuery({
    queryKey: ["outlook-email-folders-list", connection.id, input],
    queryFn: () => {
      return orgAPI.toolbox.execute({
        integration_connection_id: connection.id,
        action_name: "microsoft-outlook-email-folders-list",
        action_input: input,
      });
    },
  });
}
